import { useState, useEffect } from 'react';
import { getSafeWindow } from '../utils/window';
export function useIsMobile(query) {
  if (query === void 0) {
    query = '(max-width: 500px)';
  }
  const [isMobile, setIsMobile] = useState(() => {
    var _getSafeWindow;
    return ((_getSafeWindow = getSafeWindow()) == null ? void 0 : _getSafeWindow.matchMedia(query).matches) ?? false;
  });
  useEffect(() => {
    var _getSafeWindow2;
    const mediaQueryList = (_getSafeWindow2 = getSafeWindow()) == null ? void 0 : _getSafeWindow2.matchMedia(query);
    const listener = event => setIsMobile(event.matches);
    mediaQueryList == null || mediaQueryList.addEventListener('change', listener);
    return () => mediaQueryList == null ? void 0 : mediaQueryList.removeEventListener('change', listener);
  }, [query]);
  return isMobile;
}
//# sourceMappingURL=useIsMobile.js.map